<lib-page-layout>
  <lib-title-navbar pageHeader title="Dodaj graczy"></lib-title-navbar>

  <div class="or-px-12-px">
    @if (candidates(); as players) {
      @if (!players?.length) {
        <div class="or-mt-32-px or-text-align-center or-text-md or-h-100-pc or-align-content-center">
          <div>Brak graczy z poprzednich gierek.</div>
          <div class="or-mt-12-px">Dodaj graczy do grupki za pomocą linku.</div>

          <button
            class="button-primary-style or-h-48-px or-w-90-pc or-head-md or-mb-12-px or-mt-32-px"
            (click)="inviteViaLink()">
            <div class="or-align-items-center or-d-flex or-justify-content-center">
              <or-icon name="copy-link" size="s" class="or-color-white or-mr-12-px" />
              <span class="or-mr-12-px">Zaproś za pomocą linku</span>
            </div>
          </button>
        </div>
      }
      @if (players?.length) {
        <div
          class="or-d-flex or-justify-content-between or-mb-16-px or-mt-24-px or-head-sm or-align-items-center or-mx-8-px">
          <div class="or-color-secondary-2">Lista dawnych graczy</div>
          <div class="or-d-flex or-justify-content-between or-align-items-center">
            <div>Zaznacz wszystkich</div>
            <ion-checkbox [checked]="false" (ionChange)="selectAll($event)" class="or-ml-8-px"></ion-checkbox>
          </div>
        </div>
      }
      @for (player of players; track player.userId; let i = $index) {
        <div
          class="or-bg-white or-d-flex or-justify-content-between or-p-8-px or-mb-4-px player-box border-radius-8"
          [class.border-primary]="isSelected(player.userId)"
          [class.or-bg-selected]="isSelected(player.userId)">
          <div class="or-d-flex or-align-items-center or-w-100-pc">
            <ion-checkbox
              [checked]="isSelected(player.userId)"
              (ionChange)="selectPlayer(player.userId)"
              class="or-mr-8-px"></ion-checkbox>
            <lib-or-avatar
              [avatarUrl]="player.thumbnail"
              [initials]="player.displayName"
              [avatarSize]="'sm'"></lib-or-avatar>

            <div class="or-head-sm or-d-flex or-align-items-center">
              {{ i + 1 }}.&nbsp;
              <span class="or-truncate-at-line-1">{{ player.displayName }}</span>
            </div>
          </div>
        </div>
      }
    }
  </div>

  <lib-page-actions pageActions>
    @if (candidates()?.length) {
      <button
        (click)="inviteUsers()"
        class="button-primary-style or-h-48-px or-head-md or-w-100-pc"
        [class.disabled-button]="!hasSelectedUsers()">
        Dodaj graczy
      </button>
    }
  </lib-page-actions>
</lib-page-layout>
